export const formatDate = (date: Date) => {
  const day = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2 })
  const month = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2 })
  const year = date.getFullYear().toString().slice(2)

  return `${day}.${month}.${year}`
}
